import React from 'react';
import ReactDOM from 'react-dom/client';
// Fix: Use namespace import for react-router-dom to avoid missing exported member errors
import * as ReactRouterDOM from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import App from './App';
import './global.css';
import './i18n';

const { BrowserRouter } = ReactRouterDOM as any;

// Gestion d'erreur globale pour diagnostiquer les problèmes
window.addEventListener('error', (event) => {
  console.error('[Global Error]', event.error);
  console.error('[Global Error] Message:', event.message);
  console.error('[Global Error] Source:', event.filename, ':', event.lineno);
  
  // Afficher l'erreur dans la console pour debug Android
  if (Capacitor.isNativePlatform()) {
    console.error('[Android Debug] Erreur détectée:', {
      message: event.message,
      source: event.filename,
      line: event.lineno,
      error: event.error?.toString()
    });
  }
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Unhandled Promise Rejection]', event.reason);
  if (Capacitor.isNativePlatform()) {
    console.error('[Android Debug] Promise rejetée:', event.reason);
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Log pour diagnostiquer le chargement
console.log('[App] Initialisation de l\'application...');
console.log('[App] Capacitor Native:', Capacitor.isNativePlatform());
console.log('[App] User Agent:', navigator.userAgent);
console.log('[App] Location:', window.location.href);

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);